import type { ReactNode } from 'react'

import './toggle-group.css'

interface ToggleOption<T extends string> {
    value: T
    label: string
    icon?: ReactNode
}

interface ToggleGroupProps<T extends string> {
    options: ToggleOption<T>[]
    value: T
    onChange: (value: T) => void
    ariaLabel?: string
}

export const ToggleGroup = <T extends string>({
    options,
    value,
    onChange,
    ariaLabel,
}: ToggleGroupProps<T>) => (
    <div className="toggle-group" role="radiogroup" aria-label={ariaLabel}>
        {options.map((opt) => (
            <button
                key={opt.value}
                type="button"
                role="radio"
                aria-checked={value === opt.value}
                className={`toggle-group__btn${value === opt.value ? ' toggle-group__btn--active' : ''}`}
                onClick={() => onChange(opt.value)}
            >
                {opt.icon}
                {opt.label && <span>{opt.label}</span>}
            </button>
        ))}
    </div>
)
